import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-sign_up_modal_sign_in_redirect-click';

/**
 * Should be fired when user clicks "sign in" tertiary button in the web sign-up modal and gets redirected to the sign-in modal.
 */
export function trackSignupSignUpModalSignInRedirectClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
